var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content g9" },
    [
      _c(
        "Accord",
        { attrs: { title: "Materials" } },
        [
          _c(
            "Accord",
            { attrs: { title: "Supply amounts" } },
            [
              _c(
                "Tabs",
                {
                  attrs: {
                    menu: [
                      "Total DUN",
                      "Total Primary Packaging",
                      "DUN per Subject",
                      "Primary Packaging per Subject",
                    ],
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "tab" },
                    [
                      _c("LineChart", {
                        attrs: {
                          "chart-name": "supplyTotalDun",
                          settings: _vm.supplyTotalDunSettings,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab" },
                    [
                      _c("LineChart", {
                        attrs: {
                          "chart-name": "supplyPackaging",
                          settings: _vm.supplyPackagingSettings,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab" },
                    [
                      _c("LineChart", {
                        attrs: {
                          "chart-name": "supplyDunSubject",
                          settings: _vm.supplyDunSubjectSettings,
                          multiple: false,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tab" },
                    [
                      _c("LineChart", {
                        attrs: {
                          "chart-name": "supplyPackagingSubject",
                          settings: _vm.supplyPackagingSubjectSettings,
                          multiple: false,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Ancillary amount" } },
            [
              _c("LineChart", {
                attrs: {
                  "chart-name": "ancillaryAmount",
                  multiple: true,
                  settings: _vm.ancillaryAmountSettings,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CanShowChart",
            { attrs: { "chart-name": "Enrolment.SiteAncillaries" } },
            [
              _c(
                "Accord",
                { attrs: { title: "Site Ancillary" } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-name": "siteAncillaries",
                      multiple: true,
                      settings: _vm.siteAncillariesSettings,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "right",
                      on: { click: _vm.onDownloadSiteAncillaryClick },
                    },
                    [_vm._v("Download to excel")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CanShowChart",
            { attrs: { "chart-name": "Simulation.Batch" } },
            [
              _c(
                "Accord",
                { attrs: { title: "Packaging Campaigns" } },
                [
                  _c("LineChart", {
                    attrs: {
                      "chart-name": "packagingCampaignNew",
                      settings: _vm.packagingCampaignsSettings,
                      "is-gantt": true,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "right",
                      on: { click: _vm.onDownloadProductionPlanClick },
                    },
                    [_vm._v("Download packaging plan")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "CanShowChart",
            { attrs: { "chart-name": "Simulation.Stock" } },
            [
              _c(
                "Accord",
                { attrs: { title: "Stock Level" } },
                [
                  _c("Tabs", { attrs: { menu: ["Site", "Depot"] } }, [
                    _c(
                      "div",
                      { staticClass: "tab" },
                      [
                        _c("LineChart", {
                          attrs: {
                            "chart-name": "stockSiteNew",
                            multiple: { DUN: false, Site: true },
                            settings: _vm.stockSettings,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "tab" },
                      [
                        _c("LineChart", {
                          attrs: {
                            "chart-name": "stockDepotNew",
                            multiple: { DUN: false, Depot: true },
                            settings: _vm.stockSettings,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _vm.isSuperAdmin()
                    ? _c("div", { staticStyle: { float: "right" } }, [
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedDispensingUnits,
                                expression: "selectedDispensingUnits",
                              },
                            ],
                            attrs: { multiple: "true" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedDispensingUnits = $event.target
                                  .multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.dispensingUnits, function (option) {
                            return _c(
                              "option",
                              { domProps: { value: option.id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedLocations,
                                expression: "selectedLocations",
                              },
                            ],
                            attrs: { multiple: "true" },
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.selectedLocations = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          _vm._l(_vm.locations, function (option) {
                            return _c(
                              "option",
                              { domProps: { value: option.id } },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(option.name) +
                                    "\n                        "
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c("div", [
                          _c(
                            "button",
                            {
                              staticClass: "right",
                              on: { click: _vm.onDownloadStockClick },
                            },
                            [_vm._v("Download stock list")]
                          ),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            { attrs: { title: "Cost" } },
            [
              _c("Tabs", { attrs: { menu: ["DUN", "API", "Ancillary"] } }, [
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "costDun",
                        settings: _vm.costSettings,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "costApi",
                        settings: _vm.costSettings,
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tab" },
                  [
                    _c("LineChart", {
                      attrs: {
                        "chart-name": "costAncillary",
                        settings: _vm.costSettings,
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }